module.exports = __webpack_public_path__ + "img/489da64.jpg";